import { render } from "./WhorePage.vue?vue&type=template&id=2b42a385&scoped=true"
import script from "./WhorePage.vue?vue&type=script&lang=js"
export * from "./WhorePage.vue?vue&type=script&lang=js"

import "./WhorePage.vue?vue&type=style&index=0&id=2b42a385&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b42a385"]])

export default __exports__